import React, { useMemo, useRef, useState } from "react"
import { isEmpty } from 'lodash';
import './_style.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames"

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Atoms
import ButtonEdgeRounded from "§/src/components/atoms/buttons/button-edge-rounded"

const Gallery = ( props ) => {
	const slider = props.data;
	const imgFit = props.fit;
	const defAlt = props.defAlt;

  const sliderId = useMemo(() => "hero-" + Math.floor(Math.random() * 9999), [])
  const totalSlides = slider.length
  const [index, setIndex] = useState(1)
  const [swiperRef, setSwiperRef] = useState(null)

	// set component class
	const compClassName = 'pb-5';
	var compClass = props.className != undefined ? compClassName + ' ' + props.className : compClassName;

	return ! isEmpty( slider ) ? (

		<div comp="gallery" className={compClassName}>
			<Swiper
        onSwiper={setSwiperRef}
        onSlideChange={swiper => {
          setIndex(swiper.realIndex + 1)
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: true,
        }}
				slidesPerView={1}
				spaceBetween={0}
				loop={slider?.length === 1 ? false : true}
        watchOverflow={true}
				modules={[Autoplay, Pagination, Navigation]}
				className="simple-swiper"
				id={ sliderId }
			>

				{ slider.map(
					( heroSlide, pageIndex ) => {
						return(
							<SwiperSlide key={pageIndex}>
							{ heroSlide?.gatsbyImage && (
								<GatsbyImage
		              className="sw-image"
		              image={ getImage(heroSlide.gatsbyImage) }
		              objectFit={imgFit}
		              alt={ heroSlide?.altText || defAlt || '' }
		            />
							)}
							</SwiperSlide>
						)
					}
				) }

        {totalSlides > 1 && (
          <div className="sw-navigation">
            <ButtonEdgeRounded
              id={sliderId + "-nav-prev"}
              dir="start"
              onClick={() => swiperRef.slidePrev()}
            ></ButtonEdgeRounded>
            <ButtonEdgeRounded
              id={sliderId + "-nav-next"}
              dir="end"
              onClick={() => swiperRef.slideNext()}
            ></ButtonEdgeRounded>
          </div>
        )}
			</Swiper>

			<div className="swiper-main-pagination position-relative pt-3">
				<div id={ sliderId + '-pagination' } className="swiper-pagination"></div>
			</div>

      {totalSlides > 1 && (
        <div className="swiper-main-pagination position-relative pt-3">
          <div
            id={`${sliderId}-pagination`}
            className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"
          >
            {slider.map((elem, i) => (
              <span
                key={i}
                className={classNames("swiper-pagination-bullet", {
                  "spinner-border": i + 1 === index,
                  "border-dark": i + 1 === index,
                })}
                onClick={() => swiperRef.slideTo(i)}
              ></span>
            ))}
          </div>
        </div>
      )}

		</div>

	) : ('');

};

export default Gallery;
